import AuthenticatedLayout from "@shared/layouts/AuthenticatedLayout";
import { OnboardingTaskList } from "../components/OnboardingTaskList";
import { useOnboardingTasks } from "../hooks/useOnboardingTasks";

export default function StartHerePage() {
  const { tasks, loading, toggleTaskStatus, toggleSubtask } =
    useOnboardingTasks();

  return (
    <AuthenticatedLayout>
      <div className="flex h-screen overflow-hidden">
        <div className="relative flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
          <main>
            <OnboardingTaskList
              tasks={tasks}
              loading={loading}
              onToggleStatus={toggleTaskStatus}
              onToggleSubtask={toggleSubtask}
            />
          </main>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
